import { Work } from "@biblioteksentralen/cordata";
import { Publication, Site } from "@libry-content/types";
import { CordataWorkUrlDetails, getPath } from "@libry-content/common";
import { getLibrarySystemClient } from "@libry-content/integrations";
import { slugifyString } from "@biblioteksentralen/utils";
import { shake } from "radash";
import { normalizeIsbn } from "@libry-content/common";

/** @deprecated will be replaced by getPublicationUrl after publication migration */
export const getPublicationUrlDeprecated = ({
  publication,
  site,
}: {
  publication: Publication | undefined;
  work: Work | undefined;
  site: Site | undefined;
}) => {
  const isbn = normalizeIsbn(publication?.isbn);
  const workId = publication?.workId;
  const searchEnvironment = site?.librarySystem?.searchIntegration;
  //if search integration is enabled, try to generate a link to the work directly without link-to-publication route
  if ((searchEnvironment === "prod" || searchEnvironment === "staging") && workId) {
    const manifestationId = publication?.manifestationId;
    const cordataWorkUrlDetails: CordataWorkUrlDetails = {
      type: "Work",
      title: { mainTitle: publication.title ?? "" },
      id: workId,
    };
    return `${getPath(cordataWorkUrlDetails)}${
      manifestationId ? `?manifestationId=${manifestationId}` : isbn ? `?isbn=${isbn}` : ``
    }`;
  }
  const publicationId = publication?.id;
  const baseUrl = `/api/internal/link-to-publication?`;
  const urlParams = new URLSearchParams(
    shake({
      isbn,
      publicationId,
    })
  ).toString();
  return baseUrl + urlParams;
};

type Props = {
  publication: Publication | undefined;
  work: Work | undefined;
  site: Site | undefined;
};

//TODO: Replace getPublicationUrlDeprecated with this function after publication migration
export const getPublicationUrl = ({ publication, work, site }: Props) => {
  if (!publication) throw new Error("getUrlFromPublication: No publication available");
  const librarySystem = site?.librarySystem;
  const librarySystemClient = getLibrarySystemClient(site?.librarySystem);
  const isbn =
    publication?.isbn ??
    (publication?.manifestationId &&
      work?.expressions
        ?.flatMap(({ manifestations, aggregateManifestations }) => [
          ...(manifestations ?? []),
          ...(aggregateManifestations ?? []),
        ])
        .find((manifestation) => manifestation.id === publication.manifestationId)?.isbn[0]);
  const manifestationParam = publication.manifestationId && `?manifestationId=${publication.manifestationId}`;
  const isbnParam = isbn && `?isbn=${isbn}`;
  if (librarySystem?.searchIntegration === "prod") {
    if (work) {
      return `${getPath(work)}${manifestationParam ?? isbnParam}`;
    }
    if (!work && publication.workId) {
      return `/samling/verk/${slugifyString(publication.title)}_${publication.workId}${
        manifestationParam ?? isbnParam
      }`;
    }
  }
  const publicationUrl = publication?.id && librarySystemClient?.getLinkToRecord(publication.id);
  if (!publicationUrl) throw new Error("getUrlFromPublication: Could not get publication url");
  return publicationUrl;
};
